import { useState } from "react";
import { useNavigate } from "react-router";
import classes from "../../Challenge.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Card from "../../../../components/Card/Card";
import Button from "../../../../components/Button/Button";
import { SuperPowerServices } from "../../../../services/challenge_services";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BASE_PATH_TO_SUPER_POWERS_LIST } from "../../../../base_routes_paths/challenge_paths";

const CreateSuperpower = (props) => {
    const navigate = useNavigate();
    const [SuperPowerName, setSuperPowerName] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [SuperPowerDescription, setSuperPowerDescription] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [SuperPowerImageUrl, setSuperPowerImageUrl] = useState("");
    const [SuperPowerDuration, setSuperPowerDuration] = useState(0);
    const [SuperPowerDurationType, setSuperPowerDurationType] = useState(1);
    const [SuperPowerMultiplier, setSuperPowerMultiplier] = useState(1);
    const [SuperPowerPointsCost, setSuperPowerPointsCost] = useState(0);
    const [SuperPowerCategory, setSuperPowerCategory] = useState(1);
    const [SuperPowerID, setSuperPowerID] = useState(1);
    const [IsActive, setIsActive] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const { token } = AUTH_CONTEXT();

    const handleInputChange = (setter) => (e) => setter(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const superpowerData = {
                SuperPowerName,
                SuperPowerDescription,
                SuperPowerImageUrl,
                SuperPowerDuration,
                SuperPowerDurationType,
                SuperPowerMultiplier,
                SuperPowerPointsCost,
                SuperPowerCategory,
                SuperPowerID,
                IsActive
            };

            await SuperPowerServices.addSuperPowers(token, navigate, superpowerData);
            toast.success("Superpower created successfully!");
            navigate(BASE_PATH_TO_SUPER_POWERS_LIST);
        } catch (error) {
            toast.error("Failed to create superpower.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleNameChange = (e, locale) => {
        setSuperPowerName(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const handleNameChangeDescription = (e, locale) => {
        setSuperPowerDescription(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    return (
        <div className={classes.crumbs}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">Dashboard</Link>
                <Typography color="text.primary">SuperPower</Typography>
                <Typography color="text.primary">Create SuperPower</Typography>
            </Breadcrumbs>
            <Card className={classes.input}>
                <div className={classes.Main_div}>Add New Super power</div>
                <form onSubmit={handleSubmit}>
                    <div className={classes.subfields}>
                        <h3>SuperPower Name Translations</h3>
                        {Object.keys(SuperPowerName).map(locale => (
                            <div key={locale} className={classes.control}>
                                <label>{`Name (${locale})`}</label>
                                <input type="text" value={SuperPowerName[locale]} onChange={e => handleNameChange(e, locale)} placeholder={`Enter name for ${locale}`} />
                            </div>
                        ))}
                    </div>

                    <div className={classes.subfields}>
                        <h3>SuperPower Description Translations</h3>
                        {Object.keys(SuperPowerDescription).map(locale => (
                            <div key={locale} className={classes.control}>
                                <label>{`Name (${locale})`}</label>
                                <input type="text" value={SuperPowerDescription[locale]} onChange={e => handleNameChangeDescription(e, locale)} placeholder={`Enter Description for ${locale}`} />
                            </div>
                        ))}
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerImageUrl">SuperPowerImageUrl :</label>
                        <input
                            type="text"
                            value={SuperPowerImageUrl}
                            onChange={handleInputChange(setSuperPowerImageUrl)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerDuration">SuperPowerDuration :</label>
                        <input
                            type="number"
                            value={SuperPowerDuration}
                            onChange={handleInputChange(setSuperPowerDuration)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerDurationType">SuperPowerDurationType : </label>
                        <select
                            name="SuperPowerDurationType"
                            id="SuperPowerDurationType"
                            value={SuperPowerDurationType}
                            onChange={handleInputChange(setSuperPowerDurationType)}
                        >
                            <option value={1}>One-time use</option>
                            <option value={2}>One-day use</option>
                        </select>
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerMultiplier">SuperPowerMultiplier :</label>
                        <input
                            type="number"
                            value={SuperPowerMultiplier}
                            onChange={handleInputChange(setSuperPowerMultiplier)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerPointsCost">SuperPowerPointsCost :</label>
                        <input
                            type="number"
                            value={SuperPowerPointsCost}
                            onChange={handleInputChange(setSuperPowerPointsCost)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerCategory">SuperPowerCategory : </label>
                        <select
                            name="SuperPowerCategory"
                            id="SuperPowerCategory"
                            value={SuperPowerCategory}
                            onChange={handleInputChange(setSuperPowerCategory)}
                        >
                            <option value={1}>Challenge</option>
                            <option value={2}>SoloChallenge</option>
                            <option value={3}>Points</option>
                            <option value={4}>Streak</option>
                            <option value={5}>Attempts</option>
                        </select>
                    </div>

                    <div className={classes.control}>
                        <label htmlFor="SuperPowerID">SuperPowerID :</label>
                        <input
                            type="number"
                            id="SuperPowerID"
                            required
                            value={SuperPowerID}
                            onChange={(e) => setSuperPowerID(parseInt(e.target.value))}
                            placeholder="Enter Badge ID"
                        />
                    </div>

                    <div className={classes.selectbox} style={{ marginBottom: "2rem" }}>
                        <label htmlFor="IsActive">IsActive : </label>
                        <select
                            name="IsActive"
                            id="IsActive"
                            value={IsActive}
                            onChange={(e) => setIsActive(e.target.value)}
                        >
                            <option value={false}>False</option>
                            <option value={true}>True</option>
                        </select>
                    </div>

                    <Button type="submit" disabled={isLoading} className={classes.submitButton}>
                        {isLoading ? "Creating..." : "Add Superpower"}
                    </Button>
                </form>
            </Card>
        </div>
    );
};

export default CreateSuperpower;
